import { getUserInfo } from '@/api/account';
const state = {
  init: {},
  userInfo: '',
};

const mutations = {
  CHANGE_USERINFO: (state, data) => {
    if (!data) {
      state.userInfo = '';
      return;
    }
    state.userInfo = { ...data };
  },
};

const actions = {
  // 获取用户信息
  async getUserInfo({ commit, state }) {
    const r = await getUserInfo();
    if (!r.code) {
      throw Error();
    }
    commit('CHANGE_USERINFO', r.data);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
